import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class RouterstoreService {

  years: any = [];

  question_list_page = {
    sort: 'question',
    order: 'asc',
    max: 10,
    offset: 0,
    grade: 0,
    subject: 0,
    topic: 0,
    skill: 0,
    search: '',
    curriculum: null
  };

  tb_question_list_page = {
    sort: 'question',
    order: 'asc',
    max: 10,
    offset: 0,
    grade: 0,
    subject: 0,
    assessment: 0,
    search: ''
  };

  rg_question_list_page = {
    sort: 'question',
    order: 'asc',
    max: 10,
    offset: 0,
    grade: 0,
    subject: 0,
    search: '',
    assessment: 'All',
  };

  bm_question_list_page = {
    sort: 'question',
    order: 'asc',
    max: 10,
    offset: 0,
    grade: 0,
    subject: 0,
    benchmark: 0,
    search: ''
  };

  
  tb_tch_question_list_page = {
    sort: 'question',
    order: 'asc',
    max: 10,
    offset: 0,
    tchCategory: 0,
    tchDomain: 0,
    assessment: 0,
    search: ''
  };


  splited_url: any = [];
  topic_page: any = {
    tabValue: 'Classes',
    subject: null,
    grade: null,
    topic: null,
    topic_view: false
  };

  tchTopic_page: any = {
    tabValue: true,
    tchDomain: null,
    tchCategory: null,
    tchTopic: null,
    topic_view: false
  };

  assessment_page: any = {
    filter: 'See all',
    assessment_type: 'RA',
    subject: 0
  };

  tch_question_list_page = {
    sort: 'question',
    order: 'asc',
    max: 10,
    offset: 0,
    tchCategory: 0,
    tchDomain: 0,
    tchTopic: 0,
    tchSubTopic: 0,
    search: ''
  };

  tch_ass_question_list_page = {
    sort: 'question',
    order: 'asc',
    max: 10,
    offset: 0,
    tchCategory: 0,
    tchDomain: 0,
    search: ''
  };

  tba_page = {
    grade: 0,
    subject: 0,
    search: ''
  }

  constructor() { 
    if(this.years.length === 0) {
      var year = new Date().getFullYear();
      if(localStorage.academicMonth >= new Date().getMonth()+1) {
        year = new Date().getFullYear() - 1;
      }
      for(var i = year; i >= 2020; i--) {
        this.years.push(i)
      }    
    }
  }

  get_years() {
    var temp_years = []
      var year = new Date().getFullYear();
      if(localStorage.academicMonth > new Date().getMonth()+1) {
        year = new Date().getFullYear() - 1;
      }
      for(var i = year; i >= 2020; i--) {
        temp_years.push(i)
      }    
    
    return temp_years
  }

  reset_topic_page() {
    this.topic_page = { tabValue: 'Classes', subject: null, grade: null, topic: null, topic_view: false };
  };

  set_topice_page_subject(subject) {
    if (this.topic_page.subject === null) {
      this.topic_page.subject = subject;
    }
  };

  set_topice_page_grade(grade) {
    if (this.topic_page.grade === null) {
      this.topic_page.grade = grade;
    }
  };

  reset_assessment_page() {
    this.assessment_page = { filter: 'See all' }
  }

  current_url_service(url) {
    if (this.splited_url.length > 0) {
      this.check_con_url();
    } else {
      this.splited_url = url.split('/');
    }
  }

  check_con_url() {
    if (this.splited_url[1] === "" && this.splited_url[2] === "") {

    }
  }

  reset_tchTopic_page() {
   this.tchTopic_page = { tabValue: true, tchDomain: null, tchCategory: null, tchTopic: null, topic_view: false };
  };

  set_tchTopic_page_tchDomain(tchDomain) {
    if (this.tchTopic_page.tchDomain === null) {
      this.tchTopic_page.tchDomain = tchDomain;
    };
  };

  set_tchTopic_page_tchCategory(tchCategory) {
    if (this.tchTopic_page.tchCategory === null) {
      this.tchTopic_page.tchCategory = tchCategory;
    }
  };

}
